import { DeviceType, ToggleDeviceButtonGroup } from "./ToggleDeviceButtonGroup"

import { DesignerMode } from "../../../../types"
import { FC } from "react"
import { PageViewButtonGroup } from "./PageViewButtonGroup"

interface IPageActionsToolbarProps {
    editMode: DesignerMode,
    onEditModeChange: (type: DesignerMode) => void
    deviceType: DeviceType,
    onDeviceTypeChange: (type: DeviceType) => void
}

export const PageActionsToolbar: FC<IPageActionsToolbarProps> = ({
    editMode: viewType,
    onEditModeChange,
    deviceType,
    onDeviceTypeChange
}) => {
    return <>
        <div className='d-flex flex-wrap float-start bg-dark w-100 px-2 gap-5'>
            <PageViewButtonGroup
                groupName="page-actions"
                type={viewType}
                onChange={onEditModeChange} />
            <div className='flex-fill'></div>
            <ToggleDeviceButtonGroup
                groupName="page-actions-device-buttons"
                type={deviceType}
                onChange={onDeviceTypeChange} />
        </div>
    </>
}

